import {
  PRODUCT_IMAGE_DS01,
  PRODUCT_IMAGE_DM02,
  PRODUCT_IMAGE_DED,
  PRODUCT_IMAGE_AM02,
  PRODUCT_IMAGE_PM02,
  PRODUCT_IMAGE_PDS08,
  PRODUCT_IMAGE_VS01,
} from 'lib/product-data';

export {
  PRODUCT_IMAGE_DS01,
  PRODUCT_IMAGE_DM02,
  PRODUCT_IMAGE_DED,
  PRODUCT_IMAGE_AM02,
  PRODUCT_IMAGE_PM02,
  PRODUCT_IMAGE_PDS08,
  PRODUCT_IMAGE_VS01,
};

export const topNavContent = [
  {
    id: 'shop',
    label: 'Shop',
    subNavLists: [
      {
        list: [
          {
            text: 'DS-01®',
            title: 'Daily Synbiotic',
            media: {
              src: PRODUCT_IMAGE_DS01,
              alt: 'DS-01®',
            },
            href: '/daily-synbiotic',
            textBeforeTitle: true,
            miniSalePill: true,
          },
          {
            text: 'DM-02®',
            title: 'Daily Multivitamin',
            media: {
              src: PRODUCT_IMAGE_DM02,
              alt: 'DM-02®',
            },
            href: '/daily-multivitamin',
            textBeforeTitle: true,
          },
          {
            text: 'Save 25%',
            title: 'Daily Essentials Duo',
            media: {
              src: PRODUCT_IMAGE_DED,
              alt: 'Daily Essentials Duo',
            },
            href: '/daily-essentials-duo',
            textBeforeTitle: true,
            textInPill: true,
            disablePillDuringNewYears: true,
          },
          {
            text: 'AM-02®',
            title: 'Energy + Focus',
            media: {
              src: PRODUCT_IMAGE_AM02,
              alt: 'AM-02®',
            },
            href: '/energy-focus',
            textBeforeTitle: true,
          },
          {
            text: 'PM-02®',
            title: 'Sleep + Restore',
            media: {
              src: PRODUCT_IMAGE_PM02,
              alt: 'PM-02®',
            },
            href: '/sleep-restore',
            textBeforeTitle: true,
          },
          {
            text: 'PDS-08®',
            title: 'Pediatric Daily Synbiotic',
            media: {
              src: PRODUCT_IMAGE_PDS08,
              alt: 'PDS-08®',
            },
            href: '/pds08-daily-kids-probiotic',
            textBeforeTitle: true,
          },
          {
            text: 'VS-01™',
            title: 'Vaginal Synbiotic',
            media: {
              src: PRODUCT_IMAGE_VS01,
              alt: 'VS-01™',
            },
            href: '/vaginal-synbiotic',
            textBeforeTitle: true,
          },
        ],
      },
      // {
      //   heading: 'FOR WHOLE BODY HEALTH',
      //   headingLabel: 'New',
      //   list: [
      //     {
      //       text: 'DM–02™',
      //       title: 'Daily Multivitamin',
      //       media: {
      //         src: fpoImage,
      //         alt: 'DS-01®',
      //       },
      //     },
      //     {
      //       text: 'AM-02®',
      //       title: 'Energy & Focus',
      //       media: {
      //         src: fpoImage,
      //         alt: 'DS-01®',
      //       },
      //     },
      //     {
      //       text: 'PM-02®',
      //       title: 'Sleep + Restore',
      //       media: {
      //         src: fpoImage,
      //         alt: 'DS-01®',
      //       },
      //     },
      //   ],
      // },
    ],
    // promo: {
    //   body: 'Is DS-01® right for you?',
    //   cta: {
    //     label: 'Take Quiz',
    //     href: '/quiz',
    //   },
    // },
    extraLinkRight: {
      text: 'Shop All Products',
      url: '/products',
      transform: 'capitalize',
      underline: true,
      small: true,
    },
  },
  {
    id: 'science',
    label: 'Science',
    subNavLists: [
      {
        list: [
          {
            title: 'Approach',
            text: 'Microbiome science for human health.',
            media: {
              src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755487791/library/nav/science/approach.png',
              alt: 'Approach',
            },
            href: '/approach',
          },
          {
            title: 'Seed【 Labs 】',
            text: 'Frontier microbial science.',
            media: {
              src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755487782/library/nav/science/seedlabs.png',
              alt: 'Seed Labs',
            },
            href: '/seedlabs',
          },
          {
            title: 'Scientists',
            text: 'Leading microbiome experts.',
            media: {
              src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755487801/library/nav/science/scientists.png',
              alt: 'Scientists',
            },
            href: '/approach#our-scientists',
          },
          {
            title: 'Sustainability',
            text: 'Human impact on planetary health.',
            media: {
              src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755487761/library/nav/science/sustainability.png',
              alt: 'Sustainability',
            },
            href: '/sustainability',
          },
        ],
      },
    ],
    extraLinks: {
      heading: 'Reference',
      list: [
        {
          text: 'DS-01® Daily Synbiotic',
          url: '/reference/syn-wk',
        },
        {
          text: 'DM-02® Daily Multivitamin',
          url: '/reference/dm-wk',
        },
        {
          text: 'AM-02® Energy + Focus ',
          url: '/reference/am-wk',
        },
        {
          text: 'PM-02® Sleep + Restore',
          url: '/reference/pm-wk',
        },
        {
          text: 'PDS-08® Pediatric Synbiotic',
          url: '/reference/pds-wk',
        },
        {
          text: 'VS-01™ Vaginal Synbiotic',
          url: '/reference/vs-wk',
        },
      ],
    },
  },
  {
    id: 'learn',
    label: 'Learn',
    subNavLists: [
      {
        heading: '',
        list: [
          {
            title: 'Microbiome 101',
            text: 'The hidden ecosystem powering your health.',
            media: {
              src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755487912/library/nav/learn/microbiome.png',
              alt: 'Microbiome 101',
            },
            href: 'https://seed.com/cultured/microbiome-101',
          },
          {
            title: 'Probiotics 101',
            text: 'How these mighty bacteria shape your health.',
            media: {
              src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755487978/library/nav/learn/probiotics.png',
              alt: 'Probiotics 101',
            },
            href: 'https://seed.com/cultured/probiotics-101',
          },
        ],
      },
      {
        heading: 'Featured Articles',
        list: [
          {
            title: 'How Seed Is Setting A New Standard For Probiotic Health',
            text: '7 min read',
            media: {
              src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755487945/library/nav/learn/climate.png',
              alt: 'How Seed Is Setting A New Standard',
            },
            href: 'https://seed.com/cultured/how-seed-is-fixing-probiotic-research/',
          },
          {
            title:
              'Seeking Carbon-Capturing Bacteria off a Remote Japanese Island',
            text: '8 min read',
            media: {
              src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755488005/library/nav/learn/science.png',
              alt: 'Mapping Microbes',
            },
            href: 'https://seed.com/cultured/carbon-four-expedition/',
          },
          {
            title: 'Exploring the Microbiomes of Your Body',
            text: '12 min read',
            media: {
              src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755487966/library/nav/learn/rainbow.png',
              alt: 'Exploring Microbiomes',
            },
            href: 'https://seed.com/cultured/microbiomes-of-the-body/',
          },
        ],
      },
    ],
    extraLink: {
      text: 'All Cultured Articles',
      url: 'https://seed.com/cultured',
    },
  },
];
